import { Flex, Text, Button, Box } from "@chakra-ui/react"

export function ErrorLayoutBoundary({ resetErrorBoundary }) {
  return (
    <Flex w="100%" alignItems="center" justifyContent="center" flexDirection="column" mx="auto">
      <Text color="red.500" fontSize="3xl" mb="4">
        Ocorreu um erro ao carregar a página
      </Text>
      <Button onClick={resetErrorBoundary}>Tentar novamente</Button>
    </Flex>
  )
}
